import { render, staticRenderFns } from "./FrzStockMaturation.vue?vue&type=template&id=d080e21e"
import script from "./FrzStockMaturation.vue?vue&type=script&lang=js"
export * from "./FrzStockMaturation.vue?vue&type=script&lang=js"
import style0 from "./FrzStockMaturation.vue?vue&type=style&index=0&id=d080e21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports